import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs/dist/metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';


import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/core/services/global.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef: any;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems: Array<any> = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(private readonly eventService: EventService, private readonly router: Router, public readonly translate: TranslateService, private readonly globalService: GlobalService) {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit(): void {
    this.initialize();
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'dark');

    this._scrollElement();
  }
  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string): void {
    this.eventService.broadcast('changeLayout', layout);
  }

  ngAfterViewInit(): void {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event: any): void {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges(): void {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      this.globalService.nativeWindow.setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement(): void {
    this.globalService.nativeWindow.setTimeout(() => {
      if (this.globalService.nativeDocument.getElementsByClassName("mm-active").length > 0) {
        const currentPosition: any = this.globalService.nativeDocument.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar.getScrollElement() !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any): void {
    const els: any = this.globalService.nativeDocument.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Light sidebar
   */
  lightSidebar(): void {
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'light');
    this.globalService.nativeDocument.body.setAttribute('data-topbar', 'dark');
    this.globalService.nativeDocument.body.removeAttribute('data-sidebar-size');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-keep-enlarged');
    this.globalService.nativeDocument.body.classList.remove('vertical-collpsed');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Compact sidebar
   */
  compactSidebar(): void {
    this.globalService.nativeDocument.body.setAttribute('data-sidebar-size', 'small');
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'dark');
    this.globalService.nativeDocument.body.removeAttribute('data-topbar');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-keep-enlarged');
    this.globalService.nativeDocument.body.classList.remove('sidebar-enable');
    this.globalService.nativeDocument.body.classList.remove('vertical-collpsed');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Icon sidebar
   */
  iconSidebar(): void {
    this.globalService.nativeDocument.body.classList.add('sidebar-enable');
    this.globalService.nativeDocument.body.classList.add('vertical-collpsed');
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'dark');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-keep-enlarged');
    this.globalService.nativeDocument.body.removeAttribute('data-topbar');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Boxed layout
   */
  boxedLayout(): void {
    this.globalService.nativeDocument.body.setAttribute('data-keep-enlarged', 'true');
    this.globalService.nativeDocument.body.setAttribute('data-layout-size', 'boxed');
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'dark');
    this.globalService.nativeDocument.body.classList.add('vertical-collpsed');
    this.globalService.nativeDocument.body.classList.remove('sidebar-enable');
    this.globalService.nativeDocument.body.removeAttribute('data-topbar');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar(): void {
    this.globalService.nativeDocument.body.setAttribute('data-sidebar', 'colored');
    this.globalService.nativeDocument.body.removeAttribute('data-sidebar-size');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.classList.remove('vertical-collpsed');
    this.globalService.nativeDocument.body.removeAttribute('data-topbar');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  scrollable(): void {
    this.globalService.nativeDocument.body.setAttribute('data-layout-scrollable', 'true');
    this.globalService.nativeDocument.body.removeAttribute('data-sidebar');
    this.globalService.nativeDocument.body.classList.remove('vertical-collpsed');
    this.globalService.nativeDocument.body.removeAttribute('data-topbar');
  }


  //class active
  private parent1(parent1: any): void {
    let parent2: any;
    if (parent1) {
      parent1.classList.add('mm-active');
      parent2 = parent1.parentElement.closest('ul');
      this.parent2(parent2);
    }
  }

  private parent2(parent2: any): void {
    let parent3: any;
    if (parent2 && parent2.id !== 'side-menu') {
      parent2.classList.add('mm-show');
      parent3 = parent2.parentElement;
      this.parent3(parent3);
    }
  }

  private parent3(parent3: any): void {
    let parent4: any;
    if (parent3 && parent3.id !== 'side-menu') {
      parent3.classList.add('mm-active');
      const childAnchor: any = parent3.querySelector('.has-arrow');
      const childDropdown: any = parent3.querySelector('.has-dropdown');
      if (childAnchor) { childAnchor.classList.add('mm-active'); }
      if (childDropdown) { childDropdown.classList.add('mm-active'); }
      parent4 = parent3.parentElement;
      this.parent4(parent4);

    }
  }

  private parent4(parent4: any): void {
    let parent5: any;
    if (parent4 && parent4.id !== 'side-menu') {
      parent4.classList.add('mm-show');
      parent5 = parent4.parentElement;
      this.parent5(parent5);
    }
  }

  private parent5(parent5: any): void{
    if (parent5 && parent5.id !== 'side-menu') {
      parent5.classList.add('mm-active');
      const childanchor: any = parent5.querySelector('.is-parent');
      if (childanchor && parent5.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
    }
  }

  /**
   * Activate the parent dropdown
   */




  _activateMenuDropdown(): void {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links: any = this.globalService.nativeDocument.getElementsByClassName('side-nav-link-ref');
    let menuItemEl: any = null;
    // tslint:disable-next-line: prefer-for-of
    const paths: Array<any> = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex: number = paths.indexOf(this.globalService.nativeWindow.location.pathname);
    if (itemIndex === -1) {
      const strIndex: number = this.globalService.nativeWindow.location.pathname.lastIndexOf('/');
      const item: string = this.globalService.nativeWindow.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }


    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl: any = menuItemEl.parentElement;
      this.parent1(parentEl);
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem): boolean {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  trackByItemId(index: number, item: MenuItem): number {
    return item.id;
  }


}
